import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

const BreaksTooltip = () => {
  const [isTooltipOpen, setIsTooltipOpen] = useToggle(false)

  return (
    <Tooltip.ItemList attachment="top center" open={isTooltipOpen} toggle={setIsTooltipOpen}>
      <Icon.Medium icon="info-circle-line" color="grey1000" />
      <Box gap="s16">
        <Box>
          <Text color="grey000White" size="200" weight="bold">
            {i18n.t('shift_management.breaks.add_break.flexible.title')}
          </Text>
          <Text color="grey000White" size="200">
            {i18n.t('shift_management.breaks.add_break.flexible.description')}
          </Text>
        </Box>
        <Box>
          <Text color="grey000White" size="200" weight="bold">
            {i18n.t('shift_management.breaks.add_break.semi_flexible.title')}
          </Text>
          <Text color="grey000White" size="200">
            {i18n.t('shift_management.breaks.add_break.semi_flexible.description')}
          </Text>
        </Box>
        <Box>
          <Text color="grey000White" size="200" weight="bold">
            {i18n.t('shift_management.breaks.add_break.fixed.title')}
          </Text>
          <Text color="grey000White" size="200">
            {i18n.t('shift_management.breaks.add_break.fixed.description')}
          </Text>
        </Box>
      </Box>
    </Tooltip.ItemList>
  )
}

export default observer(BreaksTooltip)
